import TrimbleMaps from '@trimblemaps/trimblemaps-js';
import { EUProfile } from '../daws/trip';
import { DetailReportResponse } from '../pcmws/reports/detailReportResponse';
import { DirectionsReportResponse } from '../pcmws/reports/directionsReportResponse';
import { MileageReportResponse } from '../pcmws/reports/mileageReportResponse';
import { RoadTypeReport } from '../pcmws/reports/roadTypeReport';
import { StateReportResponse } from '../pcmws/reports/stateReportResponse';
import { TollReport } from '../pcmws/reports/tollReportResponse';
import { StopState } from './stopState';

// routeId, routeColor, and stops will be pulled from RouteState when needed
type RouteOptionsState = Omit<
  TrimbleMaps.RouteOptions,
  'routeId' | 'routeColor' | 'stops' | 'dataVersion'
> & {
  dataVersion?: string;
};
export enum RouteEditMode {
  AddStop,
  EditStopOptions,
}

// This will hold the base state of the route.
// Save close to what we get, minimal transforms in.
// We will transform to different shapes on the way out.

export interface RouteState {
  id: number;
  name?: string;
  color?: string;
  isVisibleOnMap?: boolean;
  isOpen?: boolean;
  editMode?: RouteEditMode;
  hasCountedForTrial?: boolean;

  stopsState: StopState[];

  // Start with a trimmed version of the map RouteOptions but this may need to expand/change later
  optionsState?: RouteOptionsState;
  // results from reports calls
  mileageReport?: MileageReportResponse;
  detailReport?: DetailReportResponse;
  drivingDirectionsReport?: DirectionsReportResponse;
  stateCountryReport?: StateReportResponse;
  roadTypeReport?: RoadTypeReport;
  tollReport?: TollReport;
  isAcceptLegacy?: boolean;
  isSavedCheck?: boolean;
  isLegacy?: boolean;
  profileId?: number;
  // If a route is not saved in DA, savedId is null.
  // If a route is a saved route from DA, savedId is a number.
  savedId?: number;
  // A route was created with a profile, but the profile can or can't be found in the profile list now.
  profileDeleted?: boolean;
  //This tripProfileId is created while saving Route. For Update route we are using this. Tt can be removed after DataAnyWhere service updates.
  tripProfileId?: number;
  historicalDataVersion?: string;
  euProfile: EUProfile;
}
